import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import ThemeTable from "../component/ThemeTable";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";
import OtherService from "../services/Other";
import ModalComponent from "../component/ModalComponent";
import toast from "react-hot-toast";
import SelectDropDown from "../component/SelectDropDown";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import LeadService from "../services/Lead";
import NoData from "../component/NoData";

function MySite() {
  const [listItems, setListItems] = useState([]);
  const [conId, setConId] = useState("");
  const [hierId, setHierId] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(true);
  const [selLang, setSelLang] = useState("");

  const getLabelLanguage = (language, key) => {
    const labels = {
      en: {
        lead_no: "Lead Number",
        created_at: "Created Date",
        status: "Status",
        customer_id: "Customer Type",
        project_name: "Project Name",
      },
    };
    return labels[language]?.[key] || key;
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      const hier = localStorage.getItem("hierId");
      setHierId(hier);

      const conId = localStorage.getItem("contactId");
      setConId(conId);
      const lang = localStorage.getItem("lang") || "en";
      setSelLang(lang);

      const token = localStorage.getItem("access_token");
      if (token) {
        try {
          const res = await LeadService.getLeads(token);
          if (res.statusCode === 401) {
          } else {
            const formattedData = res.data.map((item) => ({
              ...item,
              status: statusFunction(item.status),
            }));
            setListItems(formattedData);
          }
        } catch (error) {
          console.error("Error fetching sites:");
          toast.error("Failed to fetch sites. Please try again.");
        }
      }
      setToken(token);
      setLoading(false);
    };
    fetchData();
  }, []);

  function statusFunction(status) {
    switch (status) {
      case "0":
        return "Open";
      case "1":
        return "Ongoing";
      case "2":
        return "Closed";
      default:
        return status;
    }
  }

  function internalStatusLabel(internalStatus) {
    switch (internalStatus) {
      case "AcceptancePending":
        return "Pending";
      case "Pending":
        return "Pending";
      case "Accepted":
        return "Accepted";
      case "Rejected":
        return "Rejected";
      default:
        return internalStatus;
    }
  }

  function internalStatusColor(internalStatus) {
    switch (internalStatus) {
      case "AcceptancePending":
        return "#FFAA00";
      case "Pending":
        return "#FFAA00";
      case "Accepted":
        return "#02AD75";
      case "Rejected":
        return "#DC3545";
      default:
        return "#6c757d";
    }
  }

  function testStatus2Number(status) {
    switch (status) {
      case "Open":
        return 1;
      case "Ongoing":
        return 0;
      case "Closed":
        return 2;
      default:
        return -1;
    }
  }

  // const formatDate = (date) => {
  //   const dateTime = new Date(date);
  //   return dateTime.toLocaleString("en-US", {
  //     year: "numeric",
  //     month: "long",
  //     day: "numeric",
  //     // hour: "numeric",
  //     // minute: "numeric",
  //     // second: "numeric",
  //     // hour12: true,
  //   });
  // };
  const formatDate = (date) => {
  const dateTime = new Date(date);

  const day = String(dateTime.getDate()).padStart(2, "0");
  const month = dateTime.toLocaleString("en-US", { month: "short" });
  const year = dateTime.getFullYear();

  return `${day}-${month}-${year}`;
};

  let headers = [
    "Serial No",
    getLabelLanguage(selLang, "lead_no"),
    getLabelLanguage(selLang, "created_at"),
    getLabelLanguage(selLang, "status"),
    getLabelLanguage(selLang, "customer_id"),
    "Customer Name",
    "Site Name",
    "Site Address",
    "Construction Status",
    "Construction Stage",
    "No. Of Floors",
    "Customer Contact No.",
    // "Contractor Name",
    // "Contractor Contact Number",
  ];

  return (
    <>
      {<BreadCrumbSecttion pageTitle="My Site" currentPageName="My Site" />}
      <section className="padTop50">
        <Container>
          <Row>
            <Col>
              {loading ? (
                <div className="text-center mt-5">
                  {listItems.length === 0 && loading && (
                    <NoData title="Fetching..." />
                  )}
                </div>
              ) : listItems.length > 0 ? (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      {headers.map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {listItems.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.lead_id}</td>
                        <td>{formatDate(item.created_at)}</td>

                        <td
                          style={{
                            backgroundColor: internalStatusColor(
                              item.internal_status,
                            ),
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          {internalStatusLabel(item.internal_status)}
                        </td>

                        <td>{item.customer_type}</td>
                        <td>{item.project_contact_person}</td>
                        <td>{item.project_name}</td>
                        <td>{item.project_address_line1}</td>
                        <td>{item.construction_status_name}</td>
                        <td>{item.construction_stage_name}</td>
                        <td>{item.no_of_floor}</td>
                        <td>{item.project_contact_phone_number}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center mt-5">
                  <h5>No leads available.</h5>
                  <p>Try refreshing the page or check back later.</p>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default MySite;
